export enum PLAN_TYPE {
  CLOSED = 'C',
  OPEN = 'A',
}

export type PlanType = PLAN_TYPE;
